/**
 * JSON round-trip for computed report objects (frozen report snapshots).
 * Report datasets carry Dates (and occasionally Maps/Sets or Firestore
 * Timestamps), which plain JSON would flatten to strings or `{}`.
 */

const DATE_TAG = '__date';
const MAP_TAG = '__map';
const SET_TAG = '__set';

function encodeValue(raw) {
  if (raw instanceof Date) return { [DATE_TAG]: Number.isNaN(raw.getTime()) ? null : raw.toISOString() };
  if (raw && typeof raw === 'object' && typeof raw.toDate === 'function' && 'seconds' in raw) {
    return { [DATE_TAG]: raw.toDate().toISOString() };
  }
  if (raw instanceof Map) return { [MAP_TAG]: [...raw.entries()] };
  if (raw instanceof Set) return { [SET_TAG]: [...raw.values()] };
  if (typeof raw === 'function' || typeof raw === 'undefined') return undefined;
  return raw;
}

export function serializeReport(value) {
  return JSON.stringify(value, function replacer(key, v) {
    // `this[key]` is the pre-toJSON value, so Dates are still Dates here.
    return encodeValue(this[key] !== undefined ? this[key] : v);
  });
}

export function reviveReport(json) {
  if (!json) return null;
  return JSON.parse(json, (key, v) => {
    if (v && typeof v === 'object' && !Array.isArray(v)) {
      const keys = Object.keys(v);
      if (keys.length === 1) {
        if (keys[0] === DATE_TAG) return v[DATE_TAG] ? new Date(v[DATE_TAG]) : null;
        if (keys[0] === MAP_TAG) return new Map(v[MAP_TAG]);
        if (keys[0] === SET_TAG) return new Set(v[SET_TAG]);
      }
    }
    return v;
  });
}
